// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__2XSJG","forms":"styles_forms__39Ns6","submit":"styles_submit__3Usxy","submitActive":"styles_submitActive__132jp","title":"styles_title__3QG4p"};